import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHeader, getRequestHost, getRequestUrl } from "@tanstack/react-start/server";

// `x-forwarded-host` first: the edge terminates TLS, so the request URL names this service, not the
// site. Undefined only outside a request's lifetime, a programming error. One build serves two
// sites and `head()` gets no request, so canonical, 404 and text-file choices ask here.
export const currentHost = createIsomorphicFn()
  .server((): string | undefined => {
    // Outside a request there is no host to read, so the answer is undefined.
    try {
      return getRequestHost({ xForwardedHost: true }).split(":")[0];
    } catch {
      return undefined;
    }
  })
  .client((): string | undefined => window.location.hostname);

// The address bar's origin, for a link that names the page being read.
export const currentOrigin = createIsomorphicFn()
  .server((): string | undefined => {
    // Outside a request there is no address to read, so the answer is undefined.
    try {
      return getRequestUrl({ xForwardedHost: true, xForwardedProto: true }).origin;
    } catch {
      return undefined;
    }
  })
  .client((): string | undefined => window.location.origin);

export const currentUserAgent = createIsomorphicFn()
  .server((): string | undefined => {
    // Outside a request there is no agent to read, so the answer is undefined.
    try {
      return getRequestHeader("user-agent");
    } catch {
      return undefined;
    }
  })
  .client((): string | undefined => navigator.userAgent);
